import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getSettings, updateSettings } from "./api";
import type { SupportSettings, SupportSettingsUpdate } from "./types";

const keys = {
  all: ["settings"] as const,
};

export function useSettings() {
  return useQuery({
    queryKey: keys.all,
    queryFn: getSettings,
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: SupportSettingsUpdate) => updateSettings(patch),
    onSuccess: (data) => {
      // The PATCH echoes the full settings shape back — prime the cache directly so the
      // card baseline updates immediately (clears the dirty flag) with no refetch flicker.
      qc.setQueryData<SupportSettings>(keys.all, data);
    },
  });
}
